import { SapOdpLinkedService } from 'app/model/linkedservice/sap-odp.linkedservice';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';

/**
 * @deprecated
 */
@Metamodel.model({
    name: adfModelTypeMap.sapCdc.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, getConnectorLegacyNameByFlag(stringResources.SapOdp_DisplayText, !__IS_FABRIC_DPE__)),
        format(stringResources.ModelName_LinkedServicesTemplate, getConnectorLegacyNameByFlag(stringResources.SapOdp_DisplayText, !__IS_FABRIC_DPE__))
    ]
})
export class SapCdcLinkedService extends SapOdpLinkedService {}
